<template>
    <div>
        <div v-if="osdVisibleObj.visible && !osdVisibleObj.is_dock" v-drag-window class="osd-panel fz12">
            <div class="drag-title pl5 pr5 flex-align-center flex-row flex-justify-between osd-cal">
                <span>{{ osdVisibleObj.callsign }}</span>
                <!-- <span><a class="fz16 color-white" @click="handleCloseOsd"><CloseOutlined /></a></span> -->
            </div>
            <span><a style="color: white; position: absolute; top: 5px; right: 5px;" @click="handleCloseOsd">
                  <CloseOutlined />
                </a></span>
            <div class="osd-model-height">
                <div class="flex-column flex-align-center flex-justify-center osd-top-style">
                    <a-tooltip :title="osdVisibleObj.model">
                        <div class="flex-column flex-align-center flex-justify-center width-90">
                            <span><a-image :src="M30" :preview="false" /></span>
                            <span>{{ osdVisibleObj.model }}</span>
                        </div>
                    </a-tooltip>
                </div>
                <div class="osd">
                    <a-row>
                        <a-col span="16"
                            :style="deviceInfo.device.mode_code === EModeCode.Disconnected ? 'color: red; font-weight: 700;' : 'color: rgb(25,190,107)'">
                            {{EModeCodeMap[deviceInfo.device.mode_code as EModeCode] }}</a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="信号强度">
                                <span>信号</span>
                                <span class="ml10">{{ deviceInfo.gateway?.transmission_signal_quality }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="RC 电池电量">
                                <span>
                                    <ThunderboltOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.gateway && deviceInfo.gateway.capacity_percent !== str
                                    ? deviceInfo.gateway?.capacity_percent + ' %' : deviceInfo.gateway?.capacity_percent
                                    }}</span>
                            </a-tooltip>
                        </a-col>

                        <a-col span="6">
                            <a-tooltip title="无人机电池电量">
                                <span>
                                    <ThunderboltOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.device.battery.capacity_percent !== str ?
                                    deviceInfo.device.battery.capacity_percent + ' %' :
                                    deviceInfo.device.battery.capacity_percent }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-tooltip title="RTK Fixed">
                            <a-col span="6" class="flex-row flex-align-center flex-justify-start">
                                <span>Fixed</span>
                                <span class="ml10 circle"
                                    :style="deviceInfo.device.position_state.is_fixed === 1 ? 'backgroud: rgb(25,190,107);' : ' background: red;'"></span>
                            </a-col>
                        </a-tooltip>
                        <a-col span="6">
                            <a-tooltip title="GPS">
                                <span>GPS</span>
                                <span class="ml10">{{ deviceInfo.device.position_state.gps_number }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="RTK">
                                <span>
                                    <TrademarkOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.device.position_state.rtk_number }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="飞行模式">
                                <span>
                                    <ControlOutlined class="fz16" />
                                </span>
                                <span class="ml10">{{ EGear[deviceInfo.device.gear] }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="海拔">
                                <span>海拔</span>
                                <span class="ml10">{{ deviceInfo.device.height === str ? str :
                                    deviceInfo.device.height.toFixed(2) + ' m'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="海拔起飞高度">
                                <span>ALT</span>
                                <span class="ml10">{{ deviceInfo.device.elevation === str ? str :
                                    deviceInfo.device.elevation.toFixed(2) + ' m' }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="返航距离">
                                <span>H</span>
                                <span class="ml10">{{ deviceInfo.device.home_distance === str ? str :
                                    deviceInfo.device.home_distance.toFixed(2) + ' m' }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="水平速度">
                                <span>H.S</span>
                                <span class="ml10">{{ deviceInfo.device.horizontal_speed === str ? str :
                                    deviceInfo.device.horizontal_speed.toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="垂直速度">
                                <span>V.S</span>
                                <span class="ml10">{{ deviceInfo.device.vertical_speed === str ? str :
                                    deviceInfo.device.vertical_speed.toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="风速">
                                <span>W.S</span>
                                <span class="ml10">{{ deviceInfo.device.wind_speed === str ? str :
                                    (deviceInfo.device.wind_speed / 10).toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div class="battery-slide" v-if="deviceInfo.device.battery.remain_flight_time !== 0">
                <div class="width-100 background-535759"></div>
                <div class="capacity-percent" :style="{ width: deviceInfo.device.battery.capacity_percent + '%' }"></div>
                <div class="return-home" :style="{ width: deviceInfo.device.battery.return_home_power + '%' }"></div>
                <div class="landing" :style="{ width: deviceInfo.device.battery.landing_power + '%' }"></div>
                <div class="white-point" :style="{ left: deviceInfo.device.battery.landing_power + '%' }"></div>
                <div class="battery" :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }">
                    {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
                    {{ 10 > (deviceInfo.device.battery.remain_flight_time % 60) ? '0' :
                    ''}}{{ deviceInfo.device.battery.remain_flight_time % 60 }}
                </div>
            </div>
            <!-- 飞行指令 -->
            <DroneControlPanel :sn="osdVisibleObj.gateway_sn" :deviceInfo="deviceInfo" :payloads="osdVisibleObj.payloads">
            </DroneControlPanel>
        </div>
        <!-- 机场OSD -->
        <div v-if="osdVisibleObj.visible && osdVisibleObj.is_dock" v-drag-window class="osd-panel fz12">
            <div class="drag-title fz16 pl5 pr5 flex-align-center flex-row flex-justify-between"
                style="border-bottom: 1px solid #515151; height: 10%;">
                <span>{{ osdVisibleObj.gateway_callsign }}</span>
            </div>
            <span><a style="color: white; position: absolute; top: 5px; right: 5px;"
                    @click="handleCloseOsd">
                    <CloseOutlined />
                </a></span>
            <!-- 机场 -->
            <div class="flex-display" style="border-bottom: 1px solid #515151;">
                <div class="flex-column flex-align-stretch flex-justify-center"
                    style="width: 60px; background: #2d2d2d;">
                    <a-tooltip :title="osdVisibleObj.model">
                        <div class="flex-column  flex-align-center flex-justify-center width-90" >
                            <span v-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4TD">
                                <a-image :src="Dock_3" />
                            </span>
                            <span v-else-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3TD">
                                <a-image :src="Dock_2" />
                            </span>
                            <span v-else>
                                <a-image :src="Dock_1" />
                            </span>
                            <span v-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4TD" class="mt10">机场3</span>
                            <span v-else-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3TD" class="mt10">机场2</span>
                            <span v-else class="mt10">机场1</span>
                        </div>
                    </a-tooltip>
                </div>
                <div class="osd flex-1" style="flex: 1">
                    <a-row>
                        <a-col span="16"
                            :style="deviceInfo.dock.basic_osd?.mode_code === EDockModeCode.Disconnected ? 'color: red; font-weight: 700;' : 'color: rgb(25,190,107)'">
                            {{ EDockModeCodeMap[deviceInfo.dock.basic_osd?.mode_code as EDockModeCode] }}</a-col>
                    </a-row>
                    <a-row>
                        <a-col span="12">
                            <a-tooltip title="累计运行时间">
                                <span>
                                    <HistoryOutlined />
                                </span>
                                <span class="ml10">
                                    <span v-if="deviceInfo.dock.work_osd?.acc_time >= 2592000"> {{
                                        Math.floor(deviceInfo.dock.work_osd?.acc_time / 2592000) }}m </span>
                                    <span v-if="(deviceInfo.dock.work_osd?.acc_time % 2592000) >= 86400"> {{
                                        Math.floor((deviceInfo.dock.work_osd?.acc_time % 2592000) / 86400) }}d </span>
                                    <span v-if="(deviceInfo.dock.work_osd?.acc_time % 2592000 % 86400) >= 3600"> {{
                                        Math.floor((deviceInfo.dock.work_osd?.acc_time % 2592000 % 86400) / 3600) }}h
                                    </span>
                                    <span v-if="(deviceInfo.dock.work_osd?.acc_time % 2592000 % 86400 % 3600) >= 60"> {{
                                        Math.floor((deviceInfo.dock.work_osd?.acc_time % 2592000 % 86400 % 3600) / 60)
                                        }}min </span>
                                    <span>{{ Math.floor(deviceInfo.dock.work_osd?.acc_time % 2592000 % 86400 % 3600 %
                                        60) }} s</span>
                                </span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="12">
                            <a-tooltip title="激活时间">
                                <span>
                                    <FieldTimeOutlined />
                                </span>
                                <span class="ml10">{{ new Date((deviceInfo.dock.work_osd?.activation_time ?? 0) *
                                    1000).toLocaleString() }}
                                </span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="网络状态">
                                <span :style="qualityStyle">
                                    <span
                                        v-if="deviceInfo.dock.basic_osd?.network_state?.type === NetworkStateTypeEnum.FOUR_G">
                                        <SignalFilled />
                                    </span>
                                    <span v-else>
                                        <GlobalOutlined />
                                    </span>
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.basic_osd?.network_state?.rate }} kb/s</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="机场执行任务的总次数.">
                                <span>
                                    <CarryOutOutlined />
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.work_osd?.job_number }} </span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="媒体文件仍在上传">
                                <span>
                                    <CloudUploadOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.link_osd?.media_file_detail?.remain_upload}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip>
                                <template #title>
                                    <p>total: {{ deviceInfo.dock.basic_osd?.storage?.total }}</p>
                                    <p>used: {{ deviceInfo.dock.basic_osd?.storage?.used }}</p>
                                </template>
                                <span>
                                    <FolderOpenOutlined />
                                </span>
                                <span class="ml10" v-if="deviceInfo.dock.basic_osd?.storage?.total > 0">
                                    <a-progress type="circle" :width="20"
                                        :percent="deviceInfo.dock.basic_osd?.storage?.used * 100 / deviceInfo.dock.basic_osd?.storage?.total"
                                        :strokeWidth="20" :showInfo="false"
                                        :strokeColor="deviceInfo.dock.basic_osd?.storage?.used * 100 / deviceInfo.dock.basic_osd?.storage?.total > 80 ? 'red' : '#00ee8b'" />
                                </span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="风速">
                                <span>W.S</span>
                                <span class="ml10">{{ (deviceInfo.dock.basic_osd?.wind_speed ?? str) + ' m/s' }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="降雨量">
                                <span>🌧</span>
                                <span class="ml10">{{ RainfallEnum[deviceInfo.dock.basic_osd?.rainfall] }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="环境温度">
                                <span>°C</span>
                                <span class="ml10">{{ deviceInfo.dock.basic_osd?.environment_temperature }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="机场温度">
                                <span>°C</span>
                                <span class="ml10">{{ deviceInfo.dock.basic_osd?.temperature }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="机场湿度">
                                <span>💦</span>
                                <span class="ml10">{{ deviceInfo.dock.basic_osd?.humidity }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="工作电压">
                                <span style="border: 1px solid; border-radius: 50%; width: 18px; height: 18px; line-height: 16px; text-align: center; float: left;">V</span>
                                <span class="ml10">{{ (deviceInfo.dock.work_osd?.working_voltage ?? str) + ' mV' }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="工作电流">
                                <span style="border: 1px solid; border-radius: 50%; width: 18px; height: 18px; line-height: 15px; text-align: center; float: left;">A</span>
                                <span class="ml10">{{ (deviceInfo.dock.work_osd?.working_current ?? str) + ' mA' }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="机场无人机">
                                <span>
                                    <RocketOutlined />
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.basic_osd?.drone_in_dock }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row class="p5">
                        <a-col span="24">
                            <a-button type="primary" :disabled="dockControlPanelVisible" size="small" @click="setDockControlPanelVisible(true)">控制</a-button>
                        </a-col>
                    </a-row>
                    <!-- 机场控制面板 -->
                    <DockControlPanel v-if="dockControlPanelVisible" :sn="osdVisibleObj.gateway_sn"
                        :deviceInfo="deviceInfo" @close-control-panel="onCloseControlPanel">
                    </DockControlPanel>
                </div>
            </div>
            <!--  飞机-->
            <div class="flex-display">
                <div class="flex-column flex-align-stretch flex-justify-center"
                    style="width: 60px;  background: #2d2d2d;">
                    <a-tooltip :title="osdVisibleObj.model">
                        <div class="flex-column flex-align-center flex-justify-center width-90">
                            <span v-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4TD">
                              <a-image :src="M4t" :preview="false" />
                            </span>
                            <span v-else-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3TD">
                              <a-image :src="M3t" :preview="false" />
                            </span>
                            <span v-else><a-image :src="M30" :preview="false" /></span>
                            <span v-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M4TD">
                              M4T
                            </span>
                            <span v-else-if="deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3D || deviceInfo?.dock?.basic_osd?.sub_device?.device_model_key === DEVICE_MODEL_KEY.M3TD">
                              M3T
                            </span>
                            <span v-else>M30</span>
                        </div>
                    </a-tooltip>
                </div>
                <div class="osd flex-1">
                    <a-row>
                        <a-col span="16" :style="!deviceInfo.device || deviceInfo.device?.mode_code === EModeCode.Disconnected ? 'color: red; font-weight: 700;' : 'color: rgb(25,190,107)'">
                            {{ !deviceInfo.device ? EModeCodeMaps[EModeCode.Disconnected as EModeCode] : EModeCodeMaps[deviceInfo.device?.mode_code as EModeCode] }}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="上行质量">
                                <span>
                                    <SignalFilled />
                                    <ArrowUpOutlined style="font-size: 9px; vertical-align: top;" />
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.link_osd?.sdr?.up_quality }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="下行质量">
                                <span>
                                    <SignalFilled />
                                    <ArrowDownOutlined style="font-size: 9px; vertical-align: top;" />
                                </span>
                                <span class="ml10">{{ deviceInfo.dock.link_osd?.sdr?.down_quality }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="无人机电池电量">
                                <span>
                                    <ThunderboltOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.device && deviceInfo.device.battery.capacity_percent !== str ?
                                    deviceInfo.device?.battery.capacity_percent + ' %' : str }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip>
                                <template #title>
                                    <p>total: {{ deviceInfo.device?.storage?.total }}</p>
                                    <p>used: {{ deviceInfo.device?.storage?.used }}</p>
                                </template>
                                <span>
                                    <FolderOpenOutlined />
                                </span>
                                <span class="ml10" v-if="deviceInfo.device?.storage?.total > 0">
                                    <a-progress type="circle" :width="20"
                                        :percent="deviceInfo.device?.storage?.used * 100 / deviceInfo.device?.storage?.total"
                                        :strokeWidth="20" :showInfo="false"
                                        :strokeColor="deviceInfo.device?.storage?.used * 100 / deviceInfo.device?.storage?.total > 80 ? 'red' : '#00ee8b'" />
                                </span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-tooltip title="RTK固定">
                            <a-col span="6" class="flex-row flex-align-center flex-justify-start">
                                <span>Fixed</span>
                                <span class="ml10 circle"
                                    :style="deviceInfo.device?.position_state.is_fixed === 1 ? 'backgroud: rgb(25,190,107);' : ' background: red;'"></span>
                            </a-col>
                        </a-tooltip>
                        <a-col span="6">
                            <a-tooltip title="GPS">
                                <span>GPS</span>
                                <span class="ml10">{{ deviceInfo.device ? deviceInfo.device.position_state.gps_number :
                                    str
                                    }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="RTK">
                                <span>
                                    <TrademarkOutlined class="fz14" />
                                </span>
                                <span class="ml10">{{ deviceInfo.device ? deviceInfo.device.position_state.rtk_number :
                                    str
                                    }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="飞行模式">
                                <span>
                                    <ControlOutlined class="fz16" />
                                </span>
                                <span class="ml10">{{ deviceInfo.device ? EGear[deviceInfo.device?.gear] : str }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="海拔">
                                <span>ASL</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device.height === str ? str :
                                    deviceInfo.device?.height.toFixed(2) + ' m'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="起飞高度以上">
                                <span>ALT</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device.elevation === str ? str :
                                    deviceInfo.device?.elevation.toFixed(2) + ' m' }}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="到起点的距离">
                                <span
                                    style="border: 1px solid; border-radius: 50%; width: 18px; height: 18px; line-height: 15px; text-align: center;  display: block; float: left;">H</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device.home_distance === str ?
                                    str :
                                    deviceInfo.device?.home_distance.toFixed(2) + ' m' }}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="6">
                            <a-tooltip title="水平速度">
                                <span>H.S</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device?.horizontal_speed === str
                                    ? str :
                                    deviceInfo.device?.horizontal_speed.toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="垂直速度">
                                <span>V.S</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device.vertical_speed === str ?
                                    str :
                                    deviceInfo.device?.vertical_speed.toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                        <a-col span="6">
                            <a-tooltip title="风速">
                                <span>W.S</span>
                                <span class="ml10">{{ !deviceInfo.device || deviceInfo.device.wind_speed === str ? str :
                                    (deviceInfo.device?.wind_speed / 10).toFixed(2) + ' m/s'}}</span>
                            </a-tooltip>
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div class="battery-slide" v-if="deviceInfo.device && deviceInfo.device.battery.remain_flight_time !== 0"
                style="border: 1px solid red">
                <div class="width-100 background-535759"></div>
                <div class="capacity-percent" :style="{ width: deviceInfo.device.battery.capacity_percent + '%' }"></div>
                <div class="return-home" :style="{ width: deviceInfo.device.battery.return_home_power + '%' }"></div>
                <div class="landing" :style="{ width: deviceInfo.device.battery.landing_power + '%' }"></div>
                <div class="white-point" :style="{ left: deviceInfo.device.battery.landing_power + '%' }"></div>
                <div class="battery" :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }">
                    {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
                    {{ 10 > (deviceInfo.device.battery.remain_flight_time % 60) ? '0' :
                    ''}}{{ deviceInfo.device.battery.remain_flight_time % 60 }}
                </div>
            </div>
            <!-- 飞行指令 -->
            <DroneControlPanel :sn="osdVisibleObj.gateway_sn" :deviceInfo="deviceInfo" :payloads="osdVisibleObj.payloads">
            </DroneControlPanel>
        </div>
        <!-- liveview -->
        <div class="liveview" v-if="livestreamOthersVisible" v-drag-window>
            <div style="height: 40px; width: 100%" class="drag-title"></div>
            <a style="position: absolute; right: 10px; top: 10px; font-size: 16px; color: white;"
                @click="closeLivestreamOthers">
                <CloseOutlined />
            </a>
            <LivestreamOthers />
        </div>
        <div class="liveview" v-if="livestreamAgoraVisible" v-drag-window>
            <div style="height: 40px; width: 100%" class="drag-title"></div>
            <a style="position: absolute; right: 10px; top: 10px; font-size: 16px; color: white;"
                @click="closeLivestreamAgora">
                <CloseOutlined />
            </a>
            <LivestreamAgora />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch } from 'vue'
import { useMyStore } from '/@/store'
import M30 from '/@/assets/icons/drone/m30.png'
import M4t from '/@/assets/icons/drone/m4t.png'
import M3t from '/@/assets/icons/drone/m3t.png'
import Dock_3 from '/@/assets/icons/dock/dock_3.png'
import Dock_2 from '/@/assets/icons/dock/dock_2.png'
import Dock_1 from '/@/assets/icons/dock/dock_1.jpg'
import {
  DeviceOsd, DeviceStatus, DockOsd, EGear, EModeCode, GatewayOsd, EDockModeCode, EDockModeCodeMap, EModeCodeMaps,
  NetworkStateQualityEnum, NetworkStateTypeEnum, RainfallEnum, DEVICE_MODEL_KEY, EModeCodeMap
} from '/@/types/device'
import {
  CloseOutlined, ControlOutlined, TrademarkOutlined, ArrowDownOutlined,
  ThunderboltOutlined, SignalFilled, GlobalOutlined, HistoryOutlined, CloudUploadOutlined, RocketOutlined,
  FieldTimeOutlined, FolderOpenOutlined, RobotFilled, ArrowUpOutlined, CarryOutOutlined
} from '@ant-design/icons-vue'
import { useDockControl } from '/@/components/g-map/use-dock-control'
import DroneControlPanel from '/@/components/g-map/DroneControlPanel.vue'
import LivestreamOthers from '/@/components/livestream-others.vue'
import LivestreamAgora from '/@/components/livestream-agora.vue'
import DockControlPanel from '/@/components/g-map/DockControlPanel.vue'
import { deviceTsaUpdate } from '/@/hooks/use-g-map-tsa'
import { gcj02towgs84, wgs84togcj02 } from '/@/vendors/coordtransform'
import { useGMapCover } from '/@/hooks/use-g-map-cover'
import { PostElementsBody } from '/@/types/mapLayer'
import { MapElementEnum } from '/@/constants/map'
import { GeojsonCoordinate } from '/@/types/map'
import { EDeviceTypeName } from '/@/types'
import { useConnectMqtt } from '/@/components/g-map/use-connect-mqtt'

// 连接或断开drc
useConnectMqtt()

const store = useMyStore()

const osdVisibleObj = computed(() => {
  return store.state.osdVisible
})

const handleCloseOsd = () => {
  osdVisibleObj.value.visible = false
  store.commit('SET_OSD_VISIBLE_INFO', osdVisibleObj.value)
}
const str: string = '--'

const deviceInfo = reactive({
  gateway: {
    capacity_percent: str,
    transmission_signal_quality: str,
  } as GatewayOsd,
  dock: {

  } as DockOsd,
  device: {
    latitude: 0,
    longitude: 0,
    gear: -1,
    mode_code: EModeCode.Disconnected,
    height: str,
    home_distance: str,
    horizontal_speed: str,
    vertical_speed: str,
    wind_speed: str,
    wind_direction: str,
    elevation: str,
    position_state: {
      gps_number: str,
      is_fixed: 0,
      rtk_number: str,
      quality: str,
    },
    battery: {
      capacity_percent: str,
      landing_power: str,
      remain_flight_time: 0,
      return_home_power: str,
    },
  } as DeviceOsd
})

const qualityStyle = computed(() => {
  if (deviceInfo.dock.basic_osd?.network_state?.type === NetworkStateTypeEnum.ETHERNET ||
        (deviceInfo.dock.basic_osd?.network_state?.quality || 0) > NetworkStateQualityEnum.FAIR) {
    return 'color: #00ee8b'
  }
  if ((deviceInfo.dock.basic_osd?.network_state?.quality || 0) === NetworkStateQualityEnum.FAIR) {
    return 'color: yellow'
  }
  return 'color: red'
})

const {
  dockControlPanelVisible,
  setDockControlPanelVisible,
  onCloseControlPanel,
} = useDockControl()

const livestreamOthersVisible = computed(() => {
  return store.state.livestreamOthersVisible
})

function closeLivestreamOthers () {
  store.commit('SET_LIVESTREAM_OTHERS_VISIBLE', false)
}

const livestreamAgoraVisible = computed(() => {
  return store.state.livestreamAgoraVisible
})

function closeLivestreamAgora () {
  store.commit('SET_LIVESTREAM_AGORA_VISIBLE', false)
}

const deviceTsaUpdateHook = deviceTsaUpdate()

watch(() => store.state.deviceStatusEvent,
  data => {
    if (Object.keys(data.deviceOnline).length !== 0) {
      deviceTsaUpdateHook.initMarker(data.deviceOnline.domain, data.deviceOnline.device_callsign, data.deviceOnline.sn)
      store.state.deviceStatusEvent.deviceOnline = {} as DeviceStatus
    }
    if (Object.keys(data.deviceOffline).length !== 0) {
      deviceTsaUpdateHook.removeMarker(data.deviceOffline.sn)
      if ((data.deviceOffline.sn === osdVisibleObj.value.sn) || (osdVisibleObj.value.is_dock && data.deviceOffline.sn === osdVisibleObj.value.gateway_sn)) {
        osdVisibleObj.value.visible = false
        store.commit('SET_OSD_VISIBLE_INFO', osdVisibleObj.value)
      }
      store.state.deviceStatusEvent.deviceOffline = {}
    }
  },
  {
    deep: true
  }
)

watch(() => store.state.deviceState, data => {
  if (data.currentType === EDeviceTypeName.Gateway && data.gatewayInfo[data.currentSn]) {
    const coordinate = wgs84togcj02(data.gatewayInfo[data.currentSn].longitude, data.gatewayInfo[data.currentSn].latitude)
    deviceTsaUpdateHook.moveTo(data.currentSn, coordinate[0], coordinate[1])
    if (osdVisibleObj.value.visible && osdVisibleObj.value.gateway_sn !== '') {
      deviceInfo.gateway = data.gatewayInfo[osdVisibleObj.value.gateway_sn]
    }
  }
  if (data.currentType === EDeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
    const coordinate = wgs84togcj02(data.deviceInfo[data.currentSn].longitude, data.deviceInfo[data.currentSn].latitude)
    deviceTsaUpdateHook.moveTo(data.currentSn, coordinate[0], coordinate[1])
    if (osdVisibleObj.value.visible && osdVisibleObj.value.sn !== '') {
      deviceInfo.device = data.deviceInfo[osdVisibleObj.value.sn]
    }
  }
  if (data.currentType === EDeviceTypeName.Dock && data.dockInfo[data.currentSn]) {
    const coordinate = wgs84togcj02(data.dockInfo[data.currentSn].basic_osd?.longitude, data.dockInfo[data.currentSn].basic_osd?.latitude)
    deviceTsaUpdateHook.initMarker(EDeviceTypeName.Dock, EDeviceTypeName[EDeviceTypeName.Dock], data.currentSn, coordinate[0], coordinate[1])
    if (osdVisibleObj.value.visible && osdVisibleObj.value.is_dock && osdVisibleObj.value.gateway_sn !== '') {
      deviceInfo.dock = data.dockInfo[osdVisibleObj.value.gateway_sn]
      deviceInfo.device = data.deviceInfo[deviceInfo.dock.basic_osd.sub_device?.device_sn ?? osdVisibleObj.value.sn]
    }
  }
}, {
  deep: true
})

const shareId = computed(() => {
  return store.state.layerBaseInfo.share
})

function setLayers (resource: PostElementsBody) {
  const layers = store.state.Layers
  const layer = layers.find(item => item.id.includes(shareId.value))
  // layer.id = 'private_layer' + uuidv4()
  // layer?.elements.push(resource)
  if (layer?.elements) {
    ;(layer?.elements as any[]).push(resource)
  }
  console.log('layers', layers)
  store.commit('SET_LAYER_INFO', layers)
}

function updateCoordinates (transformType: string, element: any) {
  const geoType = element.resource?.content.geometry.type
  const type = element.resource?.type as number
  if (element.resource) {
    if (MapElementEnum.PIN === type) {
      const coordinates = element.resource?.content.geometry
        .coordinates as GeojsonCoordinate
      if (transformType === 'wgs84-gcj02') {
        const transResult = wgs84togcj02(
          coordinates[0],
          coordinates[1]
        ) as GeojsonCoordinate
        element.resource.content.geometry.coordinates = transResult
      } else if (transformType === 'gcj02-wgs84') {
        const transResult = gcj02towgs84(
          coordinates[0],
          coordinates[1]
        ) as GeojsonCoordinate
        element.resource.content.geometry.coordinates = transResult
      }
    } else if (MapElementEnum.LINE === type) {
      const coordinates = element.resource?.content.geometry
        .coordinates as GeojsonCoordinate[]
      if (transformType === 'wgs84-gcj02') {
        coordinates.forEach((coordinate, i, arr) => {
          arr[i] = wgs84togcj02(
            coordinate[0],
            coordinate[1]
          ) as GeojsonCoordinate
        })
      } else if (transformType === 'gcj02-wgs84') {
        coordinates.forEach((coordinate, i, arr) => {
          arr[i] = gcj02towgs84(
            coordinate[0],
            coordinate[1]
          ) as GeojsonCoordinate
        })
      }
      element.resource.content.geometry.coordinates = coordinates
    } else if (MapElementEnum.POLY === type) {
      const coordinates = element.resource?.content.geometry
        .coordinates[0] as GeojsonCoordinate[]
      if (transformType === 'wgs84-gcj02') {
        coordinates.forEach((coordinate, i, arr) => {
          arr[i] = wgs84togcj02(
            coordinate[0],
            coordinate[1]
          ) as GeojsonCoordinate
        })
      } else if (transformType === 'gcj02-wgs84') {
        coordinates.forEach((coordinate, i, arr) => {
          arr[i] = gcj02towgs84(
            coordinate[0],
            coordinate[1]
          ) as GeojsonCoordinate
        })
      }
      element.resource.content.geometry.coordinates = [coordinates]
    }
  }
}

watch(
  () => store.state.wsEvent,
  newData => {
    const useGMapCoverHook = useGMapCover()
    const event = newData
    let exist = false
    if (Object.keys(event.mapElementCreat).length !== 0) {
      console.log(event.mapElementCreat)
      const ele = event.mapElementCreat
      store.state.Layers.forEach(layer => {
        layer.elements.forEach(e => {
          if (e.id === ele.id) {
            exist = true
            console.log('true')
          }
        })
      })
      if (exist === false) {
        setLayers({
          id: ele.id,
          name: ele.name,
          resource: ele.resource
        })

        updateCoordinates('wgs84-gcj02', ele)
        const data = { id: ele.id, name: ele.name }
        if (MapElementEnum.PIN === ele.resource?.type) {
          useGMapCoverHook.init2DPin(
            ele.name,
            ele.resource.content.geometry.coordinates,
            ele.resource.content.properties.color,
            data
          )
        } else if (MapElementEnum.LINE === ele.resource?.type) {
          useGMapCoverHook.initPolyline(
            ele.name,
            ele.resource.content.geometry.coordinates,
            ele.resource.content.properties.color,
            data)
        } else if (MapElementEnum.POLY === ele.resource?.type) {
          useGMapCoverHook.initPolygon(
            ele.name,
            ele.resource.content.geometry.coordinates,
            ele.resource.content.properties.color,
            data)
        }
      }

      store.state.wsEvent.mapElementCreat = {}
    }
    if (Object.keys(event.mapElementUpdate).length !== 0) {
      console.log(event.mapElementUpdate)
      console.log('该功能还未实现，请开发商自己增加')
      store.state.wsEvent.mapElementUpdate = {}
    }
    if (Object.keys(event.mapElementDelete).length !== 0) {
      console.log(event.mapElementDelete)
      console.log('该功能还未实现，请开发商自己增加')
      store.state.wsEvent.mapElementDelete = {}
    }
  },
  {
    deep: true
  }
)

watch(() => store.state.deviceStatusEvent,
  data => {
    if (Object.keys(data.deviceOnline).length !== 0) {
      deviceTsaUpdateHook.initMarker(data.deviceOnline.domain, data.deviceOnline.device_callsign, data.deviceOnline.sn)
      store.state.deviceStatusEvent.deviceOnline = {} as DeviceStatus
    }
    if (Object.keys(data.deviceOffline).length !== 0) {
      deviceTsaUpdateHook.removeMarker(data.deviceOffline.sn)
      if ((data.deviceOffline.sn === osdVisibleObj.value.sn) || (osdVisibleObj.value.is_dock && data.deviceOffline.sn === osdVisibleObj.value.gateway_sn)) {
        osdVisibleObj.value.visible = false
        store.commit('SET_OSD_VISIBLE_INFO', osdVisibleObj.value)
      }
      store.state.deviceStatusEvent.deviceOffline = {}
    }
  },
  {
    deep: true
  }
)

</script>

<style lang="scss" scoped>

.g-map-wrapper {
  height: 100%;
  width: 100%;

  .g-action-panel {
    position: absolute;
    top: 16px;
    right: 16px;
    .g-action-item {
      width: 28px;
      height: 28px;
      background: white;
      color: $primary;
      border-radius: 2px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 2px;
    }
    .g-action-item:hover {
      border: 1px solid $primary;
      border-radius: 2px;
    }
  }
  .selection {
    border: 1px solid $primary;
    border-radius: 2px;
  }

  // antd button 光晕
  &:deep(.ant-btn){
    &::after {
      display: none;
    }
  }
}
.osd-panel {
  position: absolute;
  margin-left: 19.3vw;
  left: 0;
  top: 65px;
  width: 480px;
  background: #000;
  color: #fff;
  border-radius: 2px;
  opacity: 0.8;
  z-index: 500;
}
.osd > div:not(.dock-control-panel) {
  margin-top: 5px;
  padding-left: 5px;
}

.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.battery-slide {
  .capacity-percent {
    background: #00ee8b;
  }
  .return-home {
    background: #ff9f0a;
  }
  .landing {
    background: #f5222d;
  }
  .white-point {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    bottom: -0.5px;
  }
  .battery {
    background: #141414;
    color: #00ee8b;
    margin-top: -10px;
    height: 20px;
    width: auto;
    border-left: 1px solid #00ee8b;
    padding: 0 5px;
  }
}
.battery-slide > div {
  position: absolute;
  min-height: 2px;
  border-radius: 2px;
}

.liveview {
  position: absolute;
  color: #fff;
  z-index: 800;
  left: 5vw;
  margin-left: 10px;
  top: 5vw;
  text-align: center;
  width: 800px;
  height: 720px;
  background: #232323;
}

.osd-cal {
  border-bottom: 1px solid #515151;
  height: 18%;
}

.osd-model-height {
  height: 82%;
}

.osd-top-style {
  margin-top: -5px;
  padding-top: 25px;
  float: left;
  width: 60px;
  background: #2d2d2d;
}
</style>
